import { IEmployeeDTO } from 'src/api/dtos';
import { EmployeeNameFormatEnums } from 'src/shared/enums';

export const formatEmployeeName = (
  employee: Partial<IEmployeeDTO>,
  format: EmployeeNameFormatEnums = EmployeeNameFormatEnums.LNAME_FNAME,
): string => {
  const { firstName, lastName, payrollCode, employeeCode } = employee;

  switch (format) {
    case EmployeeNameFormatEnums.FNAME_LNAME:
      return `${firstName} ${lastName}`;
    case EmployeeNameFormatEnums.LNAME_FNAME_EMPCODE:
      return `${lastName}, ${firstName} (${employeeCode})`;
    case EmployeeNameFormatEnums.LNAME_FNAME_PAYROLLCODE:
      return `${employeeCode} ${lastName} (${firstName})`;
    case EmployeeNameFormatEnums.EMPCODE:
      return employeeCode ?? '--';
    case EmployeeNameFormatEnums.PAYROLLCODE:
      return payrollCode ?? '--';
    case EmployeeNameFormatEnums.EMPCODE_LNAME_FNAME:
      return `(${employeeCode}) ${lastName}, ${firstName}`;
    case EmployeeNameFormatEnums.PAYROLLCODE_LNAME_FNAME:
      return `(${payrollCode}) ${lastName}, ${firstName}`;
    case EmployeeNameFormatEnums.LNAME_FNAME:
    default:
      return `${lastName}, ${firstName}`;
  }
};

export const formatEmployeeInitials = (employee: Partial<IEmployeeDTO>, reverse?: boolean): string => {
  const lastNameFirstLetter = employee.lastName?.[0]?.toUpperCase() ?? '';
  const firstNameFirstLetter = employee.firstName?.[0]?.toUpperCase() ?? '';

  return reverse ? `${lastNameFirstLetter}${firstNameFirstLetter}` : `${firstNameFirstLetter}${lastNameFirstLetter}`;
};

export const formatInitials = (str: string | undefined) => {
  if (!str) {
    return;
  }

  if (str.length <= 1) {
    return str;
  }

  const split = str.split(' ');
  const [first, second] = split;

  if (!second) {
    return first[0].toUpperCase();
  }

  if (!first) {
    return second[0].toUpperCase();
  }

  return `${first[0].toUpperCase()}${second[0].toUpperCase()}`;
};
